import { z } from 'zod';

export const integrationCategorySchema = z.enum([
  'ecommerce',
  'crm',
  'payments',
  'analytics',
  'data_warehouse',
  'forms',
  'support',
  'productivity',
  'auth',
  'custom',
]);

export const integrationSchema = z.object({
  slug: z.string(),
  name: z.string(),
  category: integrationCategorySchema,
  logoEmoji: z.string().optional(),
  description: z.string(),
  authType: z.enum(['oauth', 'api_key', 'webhook', 'built_in']),
  status: z.enum(['connected', 'available', 'pending', 'beta', 'soon']).default('available'),
  events: z.array(z.string()).default([]),
});

export type IntegrationCategory = z.infer<typeof integrationCategorySchema>;
export type Integration = z.infer<typeof integrationSchema>;
